import React, { useState } from "react";
import { Link } from "react-router-dom";
import TermosTexto from "./TermosTexto";
import "../estilo.css";

export default function Rodape() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <footer className="quantum-footer">
        <div className="footer-content container-fluid">
          <div className="row">
            <div className="col-sm-4 footer-section">
              <img
                src={require("../img/QuantumEA.png")}
                alt="Quantum Trades"
                className="footer-logo"
              />
              <p className="footer-description">
                Quantum Trades é um ecossistema de robôs para MetaTrader 5,
                com soluções para automação, leitura de viés e operações
                mais dinâmicas em diferentes cenários de mercado.
              </p>

              <div style={{ marginTop: "16px" }}>
                <Link to="/planos" className="footer-link" style={{ display: "inline-block", marginRight: "14px" }}>
                  Ver planos
                </Link>
                <Link to="/cadastro" className="footer-link" style={{ display: "inline-block" }}>
                  Criar conta
                </Link>
              </div>
            </div>

            <div className="col-sm-4 footer-section">
              <h4>Navegação</h4>
              <ul className="footer-links">
                <li><Link to="/">Início</Link></li>
                <li><Link to="/planos">Planos</Link></li>
                <li><Link to="/indicadores">Indicadores</Link></li>
                <li><Link to="/portifolio">Portfólio</Link></li>
                <li><Link to="/cadastro">Cadastro</Link></li>
                <li><Link to="/contato">Contato</Link></li>
              </ul>
            </div>

            <div className="col-sm-4 footer-section">
              <h4>Contato</h4>
              <p>Email: <a href="mailto:contato@quantumtrades.com.br">contato@quantumtrades.com.br</a></p>
              <p>WhatsApp: <a href="https://wa.me/5542984241307" target="_blank" rel="noreferrer">(42) 98424-1307</a></p>
              <p>YouTube: <a href="https://www.youtube.com/@QuantumTradesBR" target="_blank" rel="noreferrer" className="footer-link">@QuantumTradesBR</a></p>
              <p>Telegram: <a href="https://t.me/QuantumTradesBr" target="_blank" rel="noreferrer" className="footer-link">@QuantumTradesBR</a></p>

              <div className="telegram-qrcode-wrapper">
                <img
                  src={require("../img/LinkTelegramQuantemTradesBR.png")}
                  alt="Grupo Telegram Quantum Trades"
                  className="telegram-qrcode-small"
                />
              </div>
            </div>
          </div>

          <div
            style={{
              marginTop: "30px",
              paddingTop: "22px",
              borderTop: "1px solid rgba(255,255,255,0.08)",
              textAlign: "center",
            }}
          >
            <p className="footer-terms" style={{ marginTop: 0 }}>
              O uso dos robôs da Quantum Trades envolve riscos financeiros.
              Resultados passados não garantem resultados futuros.
              Ao utilizar qualquer solução da plataforma, você concorda com os nossos termos de uso.
            </p>

            <div style={{ marginTop: "10px" }}>
              <button className="footer-terms-btn" onClick={() => setOpen(true)}>
                Ler termos completos
              </button>
            </div>

            <p className="footer-copy">
              © {new Date().getFullYear()} Quantum Trades — Todos os direitos reservados.
            </p>
          </div>
        </div>
      </footer>

      {open && (
        <div className="termos-modal-overlay" onClick={() => setOpen(false)}>
          <div className="termos-modal" onClick={(e) => e.stopPropagation()}>
            <h3>Termos e Condições de Uso</h3>
            <div className="termos-text">
              <TermosTexto />
            </div>
            <button className="footer-terms-btn" onClick={() => setOpen(false)}>
              Fechar
            </button>
          </div>
        </div>
      )}
    </>
  );
}
